import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn's class helper: `clsx` for conditionals, `twMerge` so a later Tailwind class wins over an earlier
 *  conflicting one instead of both landing in the DOM. */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
